
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { database, storage } from '../firebase';
import { ref, push, set } from 'firebase/database';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';

const TimelineForm = () => {
  const navigate = useNavigate();
  const [post, setPost] = useState({ title: '', description: '' });
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!post.title && !post.description && !imageFile) {
      setError('Debes agregar un título, una descripción o una imagen.');
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const newPost = { createdAt: Date.now() };

      if (imageFile) {
        const imageName = `timeline-${Date.now()}`;
        const imageRef = storageRef(storage, `timeline/${imageName}`);
        await uploadBytes(imageRef, imageFile);
        newPost.imageUrl = await getDownloadURL(imageRef);
      }

      if (post.title) {
        newPost.title = post.title;
      }

      if (post.description) {
        newPost.description = post.description;
      }

      const newPostRef = push(ref(database, 'timeline'));
      await set(newPostRef, newPost);

      alert('Publicación agregada con éxito');
      navigate('/');
    } catch (err) {
      setError('Error al agregar la publicación');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPost((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleRemoveImage = () => {
    setImageFile(null);
    setImagePreview('');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 max-w-lg mx-auto bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
      <h2 className="text-2xl font-bold text-center text-blue-600">Agregar Novedad al Timeline</h2>

      {error && <p className="text-red-500 text-center">{error}</p>}

      <div>
        <label htmlFor="title" className="block text-gray-700 text-sm font-bold mb-2">Título</label>
        <input
          type="text"
          id="title"
          name="title"
          value={post.title}
          onChange={handleChange}
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        />
      </div>

      <div>
        <label htmlFor="description" className="block text-gray-700 text-sm font-bold mb-2">Descripción</label>
        <textarea
          id="description"
          name="description"
          value={post.description}
          onChange={handleChange}
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          rows="3"
        ></textarea>
      </div>

      <div>
        <label className="block text-gray-700 text-sm font-bold mb-2">Imagen</label>
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          onChange={handleImageChange}
          className="hidden"
        />
        <button
          type="button"
          onClick={() => fileInputRef.current.click()}
          className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        >
          Seleccionar Imagen
        </button>
        {imagePreview && (
          <div className="relative m-1 mt-2">
            <img src={imagePreview} alt="Preview" className="w-40 h-40 object-cover rounded" />
            <button
              type="button"
              onClick={handleRemoveImage}
              className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs"
            >
              X
            </button>
          </div>
        )}
      </div>

      <button
        type="submit"
        disabled={isLoading}
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full"
      >
        {isLoading ? 'Agregando...' : 'Agregar Novedad'}
      </button>
    </form>
  );
};

export default TimelineForm;
